import React from 'react';
import linkify from 'linkify-it';

// Instantiate linkify
let linkifyInstance = linkify();

const HighlightLinks = ({text}) => {
  // Find all URL-like strings in text
  const links = linkifyInstance.match(text);

  if(!links){
    // If there are no links, return plain text
    return <p>{text}</p>;
  }

  let processed = [];
  let lastIndex = 0;

  links.forEach(link => {
    let startIndex = link.index;
    // Add text before link
    if(startIndex > lastIndex){
      processed.push(
          <span>{text.substring(lastIndex, startIndex)}</span>
      );
    }
    // Add link
    processed.push(
        <a href={link.url} target="_blank" rel="noopener noreferrer">
          {text.substring(startIndex, startIndex + link.lastIndex - startIndex)}
        </a>
    );
    lastIndex = link.lastIndex;
  });
  // Add text after last link
  if(lastIndex < text.length - 1){
    processed.push(
        <span>{text.substring(lastIndex, text.length - 1)}</span>
    );
  }
  return <p>{processed}</p>;
};

export default HighlightLinks;